import merge from 'lodash/merge';

export default function mergeStyles(defaultStyles, customStyles) {
  return merge(defaultStyles, customStyles);
}
